import React, {ReactNode} from 'react';
import Page, {PageType} from '@episerver/spa-core/Page';
import CellcomSalesPageData from '../../Models/Content/CellcomSalesPageData';
import ContentArea from '@episerver/spa-core/Components/ContentArea';

import './StandardPage.scss';

export default class CellcomSalesPage extends Page<CellcomSalesPageData> {
  protected pageType = PageType.Other;

  public render(): ReactNode {
    return <ContentArea context={this.getContext()} data={this.props.data.mainContentArea} propertyName='mainContentArea' />;
  }
}
